import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import getSbatGroupInstructorsByCategory from '@classCreation/utils/getSbatGroupInstructorsByCategory';
import { INSTRUCTOR_CATEGORIES } from '@classCreation/data/instructorCategories';
import SbatGroupResourceType from 'propTypes/sbatGroupResourceType';

function SbatGroupInstructors({ sbatGroup }) {
  const primaryInstructorName = useMemo(() => {
    return getSbatGroupInstructorsByCategory(
      sbatGroup,
      INSTRUCTOR_CATEGORIES.primary
    )
      .map(({ instructor }) => instructor.user.name)
      .join(', ');
  }, [sbatGroup]);

  const secondaryInstructorName = useMemo(() => {
    return getSbatGroupInstructorsByCategory(
      sbatGroup,
      INSTRUCTOR_CATEGORIES.secondary
    )
      .map(({ instructor }) => instructor.user.name)
      .join(', ');
  }, [sbatGroup]);

  if (primaryInstructorName || secondaryInstructorName) {
    return (
      <>
        {primaryInstructorName}
        {secondaryInstructorName && `, ${secondaryInstructorName}`}
      </>
    );
  } else {
    return 'N/A';
  }
}

SbatGroupInstructors.propTypes = {
  sbatGroup: SbatGroupResourceType,
  trimIfMany: PropTypes.bool,
};

export default SbatGroupInstructors;
